import Collection from "../../data-structures/collection";
import Status from "./status";
import Task from "../task/task";
import TaskStatusManager from "../../gd/manager/task-status-manager";

export enum WorkflowType {
    TASK_FROM_TASK_TYPE = 1,
    TASK_FROM_PROJECT   = 2,
    // PROJECT             = 3
}

// const debug = "TaskWorkflow"
const debug = false

export default class TaskWorkflow extends Collection<Status> {

    public type             : WorkflowType | null  = null
    public fromProjectId    : ID | null = null

    constructor(models: Status[]=[]) {
        super(models)
    }

    static initByTask(task:Task):TaskWorkflow {
        return TaskStatusManager.getWorkflow(task)
    }

    // set disable property
    applyACL(task:Task) {

        debug && console.log(debug, "applyACL")

        this.initKey()

        this.models.map(status=>{
           status.disabled = !gd.ac.task.useStatus(task, status, this)
        })
    }

    // apply key index (used to calculate next / prev status)
    initKey() {
        this.models.map((status, key)=>{
            status.key = key
        })
    }

    public removeClosedStatuses() {
        this.models.map((status:Status)=>{
            if (status.isClosed) {
                this.remove(status.id)
            }
        })
    }

    getStatusesForSelector() {

        // if (this.props.doNotShowClosedStatuses) {
        //     taskStatuses = _.filter(taskStatuses,(status)=>status.systemStatus < 5)
        // }

        const grouped = _.chain(this.models)
            .orderBy((status:Status)=>status.systemStatus, 'asc')
            .groupBy((status:Status)=>{
                switch (status.systemStatus){
                    case 1:
                        return 'new';
                    case 2:
                    case 3:
                        return 'in-progress';
                }
                return 'closed';
            })
            .toPairs()
            .value();

        return grouped

    }

    resetFromIds(statusIds: ID[]) {

        const models : Status[] = []

        statusIds.map(statusId=>{

            const sessionStatus = gd.session.statuses.get(statusId)

            if (!sessionStatus) {
                console.error("try using deleted status")
                return
            }

            models.push(new Status({
                id             : sessionStatus.id,
                systemStatus   : sessionStatus.systemStatus,
                name           : sessionStatus.name,
                color          : sessionStatus.color,
                description    : sessionStatus.description,
                isDeleted      : sessionStatus.isDeleted
            }))
        })

        this.reset(models)

    }

    resetFromConfig(statusesConfig: any[]) {

        const models : Status[] = []

        statusesConfig.map(statusConfig=>{
            models.push(new Status({
                id             : statusConfig.id,
                systemStatus   : statusConfig.systemStatus,
                name           : statusConfig.name,
                color          : statusConfig.color,
                description    : statusConfig.description,
                isDeleted      : statusConfig.isDeleted
            }))
        })

        this.reset(models)

    }

    public orderBySystemStatus() {
        this.models = _.orderBy(this.models, 'systemStatus', 'asc');
    }

    // used in checkbox to close / open can return null!
    public getDefaultClosedStatus():Status|null {

        // we need to close - find closed statuses
        const orderedClosedStatuses = _.chain(this.models)
            .filter(status=>status.isClosed && !status.disabled)
            .sortBy("systemStatus")
            .value();

        const status = orderedClosedStatuses[0]

        if (status) return status
        else return null
    }

    public getDefaultOpenStatus():Status|null {

        // we need to close - find closed statuses
        const orderedClosedStatuses = _.chain(this.models)
            .filter(status=>status.isOpen && !status.disabled)
            .sortBy("systemStatus")
            .value();

        const status = orderedClosedStatuses[0]

        if (status) return status
        else return null
    }

    public toJSON(): JSONArray {
        return super.toJSON();
    }
}